(function () {
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.1 }
  );

  function observe() {
    document.querySelectorAll('.card-wrapper:not(.is-visible)').forEach(function (el) {
      observer.observe(el);
    });
  }

  observe();

  // Re-observe after AJAX collection filtering replaces the grid
  var productGrid = document.getElementById('CollectionProductGrid');
  if (productGrid) {
    new MutationObserver(function () {
      observe();
    }).observe(productGrid, { childList: true, subtree: true });
  }
})();
